import { render, staticRenderFns } from "./swipe-example.vue?vue&type=template&id=a50f7cc8"
import script from "./swipe-example.vue?vue&type=script&lang=js"
export * from "./swipe-example.vue?vue&type=script&lang=js"
import style0 from "../transition.less?vue&type=style&index=0&prod&lang=less&external"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports